import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  if (movies.length === 0) return null;
  return (
    <section>
      <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
        相关推荐
      </h2>
      <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5">
        {movies.map((movie) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
          >
            <div className="aspect-[2/3] w-full overflow-hidden bg-primary-950">
              <img
                src={movie.poster}
                alt={movie.title}
                title={movie.title}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-2.5">
              <p className="font-label text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-accent-600">
                {movie.title}
              </p>
              <p className="mt-0.5 font-label text-xs text-foreground-500">
                {movie.year}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}